import React from 'react';
import MonetizationOnOutlined from '@material-ui/icons/MonetizationOnOutlined';

import Component from '../../Component';
import { h6, h5, rowCenter } from '../../../resources/styles';
import { getImage } from '../../../resources/images';
import { merge } from '../../../utils';
class HotelOwners extends Component {

    render = () => <div style={merge(styles.container, this.props.style)} className={this.props.className}>
        <img src={getImage('blue-bedroom-campaign.jpg')} alt='coins-on-table' style={styles.image} />
        <div style={merge(styles.text, { top: 0 })}><span style={styles.highlight}>25000+</span>&nbsp;{this.guc('hotel_owners_have')}&nbsp;<span style={styles.highlight}>OYO</span>&nbsp;globally</div>
        <div style={merge(styles.text, { bottom: 0 })}><MonetizationOnOutlined style={styles.icon} />Join the network and maximise your&nbsp;<span style={styles.highlight}>earning</span>&nbsp;</div>
    </div>;

}

export default HotelOwners;

const styles = {

    container: { height: 350, width: 700, position: 'relative', borderRadius: 10, overflow: 'hidden', boxShadow: 'var(--shadow-dark)' },

    image: { height: '100%', width: '100%', objectFit: 'cover' },

    text: { ...h6, ...rowCenter, justifyContent: 'center', padding: '16px 32px', position: 'absolute', color: 'white', backgroundColor: '#0003', width: '100%', boxSizing: 'border-box' },

    highlight: { ...h5, color: 'var(--theme-color)' },

    icon: { transform: 'rotate(16deg)', marginRight: 8 },

};